'use strict'

require('/aerospace-application/src/js/picturefill.min.js')
const FontFaceObserver = require('/aerospace-application/src/js/fontfaceobserver.standalone.js')
const { enableScroll, disableScroll } = require('/aerospace-application/src/js/scroll-disabler.js')

const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
const isFirefox = (navigator.userAgent.toLowerCase().indexOf('firefox') > -1)
document.body.classList.toggle('is-safari', isSafari)
const MOBILE_BREAKPOINT = 765
const DEBUG = (localStorage.DEBUG === 'true')

/** dasilva utils **/
function getUserZoom () {
  return window.innerWidth / window.outerWidth
}

// Array from simple polyfill
if (!Array.from) {
  Array.from = function (iterable) {
    const arr = []
    for (let i = 0; i < iterable.length; ++i) {
      arr.push(iterable[i])
    }
    return arr
  }
}

const TAP_MAX_OFFSET = 30
const TAP_MIN_COOLDOWN = 100
function onTap (elem, callback) {
  elem.style.cursor = 'pointer'

  let lastTapped = Date.now()
  elem.onclick = function (e) {
    if (Date.now() - lastTapped < TAP_MIN_COOLDOWN) return
    lastTapped = Date.now()
    return callback.call(this, e)
  }

  let startX, startY
  let activeTouchIdentifier
  elem.ontouchstart = (e) => {
    DEBUG && console.log('ontouchstart')
    if (!(e instanceof TouchEvent)) return
    if (e.touches.length !== 1) {
      activeTouchIdentifier =
      startX = startY = null
      return
    }
    activeTouchIdentifier = e.touches[0].identifier
    startX = e.changedTouches[0].screenX
    startY = e.changedTouches[0].screenY
    DEBUG && console.log('touch start happened', activeTouchIdentifier)
  }
  elem.ontouchend = function (e) {
    DEBUG && console.log('ontouchend')
    if (!(e instanceof TouchEvent)) return
    const timeSinceLastTap = (Date.now() - lastTapped)
    if (timeSinceLastTap < TAP_MIN_COOLDOWN || e.touches.length !== 1 || activeTouchIdentifier == null) {
      activeTouchIdentifier =
      startX = startY = null
      return
    }
    const endX = e.changedTouches[0].screenX
    const endY = e.changedTouches[0].screenY
    const offset = (Math.abs(endX - startX) + Math.abs(endY - startY))
    activeTouchIdentifier = null
    startX = null
    startY = null
    if (offset <= TAP_MAX_OFFSET) {
      lastTapped = Date.now()
      return callback.call(this, e)
    }
    DEBUG && console.log('touch end processed', offset)
  }
}

function createFloatingDebuggingBlock () {
  if (!localStorage.DEBUG) return { style: {} }
  const floaty = document.createElement('div')
  floaty.style.width = '10px'
  floaty.style.height = '10px'
  floaty.style.background = 'red'
  floaty.style.position = 'absolute'
  floaty.style.left = `${Math.random() * 10}px`
  floaty.style.opacity = 0.8
  floaty.style.zIndex = 100000000
  document.body.appendChild(floaty)
  return floaty
}

function clamp (min, val, max) {
  return Math.max(min, Math.min(max, val))
}
/** eof dasilva utils **/

// `getPosition` is not affected by CSS transforms! :)
function getPosition(element, debug) {
  debug && DEBUG && console.log('calculating position y for', element)
  var xPosition = 0;
  var yPosition = 0;

  while(element) {
    debug && DEBUG && console.log(element, element.offsetTop)
    xPosition += element.offsetLeft
    yPosition += element.offsetTop
    element = element.offsetParent
  }
  debug && DEBUG && console.log('position y is ', yPosition)

  if (isSafari) yPosition *= getUserZoom()

  return { x: xPosition, y: yPosition };
}

const machine = document.querySelector('.xray-machine')
const machineOutside = machine.querySelector('.xray-machine__outside')
const machineInside = machine.querySelector('.xray-machine__inside')
const xrayLine = document.querySelector('.xray-line')
const multicoreBand = document.querySelector('.js-multi-core-band')
const calibreSpecStatsImage = document.querySelector('.calibre-spec-stats-image-container img')
let machineOffsetTop = 35
const machineHeight = 800
let xrayY

let populatedTechStatsAsLayerYet = false
const techStats = document.querySelector('.tech-stats')
let techStatsY

let xrayMachineStartPinY
let xrayMachineEndPinY
let trueMultiCoreCueY
let avionicsHeartY

let zoom = 1
let SLOW_FACTOR = 0.25
let currentClipTop = -1
let multiCoreLastFactor = -1

const specLinesCenterPosition = [0, 0, 0]
const specLines = Array.from(document.querySelectorAll('.avionics-ai-section p'))
function setUpSpecLines () {
  setTimeout(function () {
    specLines.forEach((line, i) => {
      const width = line.clientWidth
      const centerPosition = -(width - window.innerWidth) / 2
      specLinesCenterPosition[i] = centerPosition
      line.style.transform = `translateX(${centerPosition}px)`
    })
  }, 300)
}

const slides = Array.from(document.querySelectorAll('.slide-like'))
function adjustSlidesHeight () {
  // innerHeight is unnaffected by zoom
  const innerHeight = window.innerHeight
  slides.forEach(slide => {
    const prevMinHeight = slide.style.minHeight.replace('px', '')
    slide.style.minHeight = (prevMinHeight
      ? Math.max(innerHeight, prevMinHeight)
      : innerHeight) + 'px'
  })
}

const MAX_OPACITY_RAD = 250
const MAX_OPACITY_FADEOFF = 300
let pastLinesOpacity = -1
function adjustFloatingSpecLines (scrollTop) {
  const offset = scrollTop - avionicsHeartY
  const opacity = Math.abs(offset) < MAX_OPACITY_RAD
    ? 1
    : Math.max(0, ((MAX_OPACITY_RAD + MAX_OPACITY_FADEOFF) - Math.abs(offset)) / MAX_OPACITY_FADEOFF)
  if (pastLinesOpacity === opacity && opacity === 0) return
  pastLinesOpacity = opacity
  specLines.forEach((line, i) => {
    const direction = (i === 1 ? 1 : -1)
    const centerPosition = specLinesCenterPosition[i]
    const speedFactor = 0.5
    const position = centerPosition + direction * offset * speedFactor
    line.style.transform = `translateX(${position}px)`
    line.style.opacity = opacity
  })
}

const parallaxItems = []
function updateDynamicParallaxInfoForItem (obj) {
  const height = obj.elem.clientHeight
  const midY = getPosition(obj.elem).y + height / 2
  obj.midY = midY
  obj.height = height
  return obj
}
function adjustParallaxItemsData () {
  parallaxItems.forEach(updateDynamicParallaxInfoForItem)
}

function setUpParallaxItems () {
  Array.from(document.querySelectorAll('.js-parallax')).forEach(elem => {
    const speed = Number(elem.dataset.accel)
    const parallaxItem = {
      elem,
      parallaxSpeed: speed,
      initialTransform: window.innerWidth > 500
        ? elem.dataset.desktopTransform
        : elem.dataset.mobileTransform
    }
    if (parallaxItem.initialTransform == null) {
      parallaxItem.initialTransform = ''
    }
    updateDynamicParallaxInfoForItem(parallaxItem)
    parallaxItems.push(parallaxItem)
  })
}
setUpParallaxItems()

function randomizeDigit () {
  this.innerHTML = Math.random() > 0.5 ? '1' : '0'
}

function adjustParallaxItems (scrollTop) {
  scrollTop += window.innerHeight / 2
  parallaxItems.forEach(({ elem, midY, height, parallaxSpeed, initialTransform }) => {
    const isOutOfViewport = (Math.abs(midY - scrollTop) > window.innerHeight + height)
    if (isOutOfViewport) return
    const yOffset = (midY - scrollTop) * parallaxSpeed
    elem.style.transform = initialTransform + ` translateY(${yOffset}px)`
  })
}

/* SCROLL HANDLER */
document.addEventListener('scroll', onScroll)
function onScroll () {
  const scrollTop = window.scrollY / zoom
  adjustXrayMachine(scrollTop)
  adjustTrueMultiCoreBand(scrollTop)
  adjustFloatingSpecLines(scrollTop)
  adjustParallaxItems(scrollTop)
  adjustMobileNavPosition(scrollTop)
  adjustRockSolidHighCustomizationFade(scrollTop)
}

const xrayBlock = createFloatingDebuggingBlock()
const clientXrayBlock = createFloatingDebuggingBlock()
const clipTopBlock = createFloatingDebuggingBlock()
const machineTopBlock = createFloatingDebuggingBlock()
clientXrayBlock.style.position = clipTopBlock.style.position = machineTopBlock.style.position = 'fixed'
clientXrayBlock.style.background = 'green'
clipTopBlock.style.background = 'yellow'
machineTopBlock.style.background = 'purple'

const headerTextFont = new FontFaceObserver('IBMPlex', { weight: 400 })
const headerTextFontBold = new FontFaceObserver('IBMPlex', { weight: 700 })
headerTextFont.load().then(_ => headerTextFontBold.load())
  .then(forceRecalculateMachineOffsetTop)
  .catch(forceRecalculateMachineOffsetTop)

function forceRecalculateMachineOffsetTop () {
  onWindowResize()
}

const highContainer = document.querySelector('.high')
function adjustRockSolidHighCustomizationFade (scrollTop) {
  const midTextTop = 143
  const xrayTop = (xrayY - scrollTop)
  const shouldBePhase1 = (xrayTop > midTextTop)
  highContainer.classList.toggle('phase1', shouldBePhase1)
  highContainer.classList.toggle('phase2', !shouldBePhase1)
}

function adjustXrayMachine (scrollTop) {
  const clientXrayY = xrayY - scrollTop
  xrayBlock.style.top = xrayY + 'px'
  clientXrayBlock.style.top = clientXrayY + 'px'
  machineTopBlock.style.top = machineOffsetTop + 'px'

  /* TODO:
   * - custom parallax effect shouldn't be in action at all times
  */

  /* adjust mask clip size */
  const clipTop = clamp(0, clientXrayY - machineOffsetTop, machineHeight) + 1
  clipTopBlock.style.top = `${clipTop + machineOffsetTop}px`
  if (currentClipTop !== clipTop) {
    currentClipTop = clipTop
    machineOutside.style.clip = `rect(0px, 700px, ${clipTop}px, 0px)`
    machineInside.style.clip = `rect(${clipTop}px, 700px, ${machineHeight}px, 0px)`
  }

  /* fix weird issue, ignore */
  if (!populatedTechStatsAsLayerYet && scrollTop + 200 > techStatsY) {
    populatedTechStatsAsLayerYet = true
    techStats.style.zIndex = 3
  }

  /* custom parallax effect for the xray machine */
  let distanceAbove = xrayMachineStartPinY - scrollTop
  const MAX_OFFSET = 100
  if (distanceAbove > 0) {
    machine.style.transform = `translateY(${-Math.min(MAX_OFFSET, distanceAbove * SLOW_FACTOR)}px)`
  } else {
    let distanceBelow = scrollTop - xrayMachineEndPinY
    if (distanceBelow > 0) {
      machine.style.transform = `translateY(${Math.min(MAX_OFFSET, distanceBelow * SLOW_FACTOR)}px)`
    } else {
      machine.style.transform = `translateY(0px)`
    }
  }
}

function adjustTrueMultiCoreBand (scrollTop) {
  const distanceAboveMultiCore = Math.max(0, trueMultiCoreCueY - scrollTop)
  const distanceAboveMultiCoreFactored = Math.min(1, (distanceAboveMultiCore / window.innerHeight))
  if (multiCoreLastFactor !== distanceAboveMultiCoreFactored) {
    multiCoreLastFactor = distanceAboveMultiCoreFactored
    multicoreBand.style.transform = `translateY(${-80 * distanceAboveMultiCoreFactored}px)`
  }
}

function adjustBlackSpecStatsSection () {
  const topMargin = 0.122
  const leftMargin = 0.443
  const rightMargin = 0.13
  const bottomMargin = 0.068
  const verticalSizeInImage = 0.81
  const horizontalSizeInImage = 0.426
  const verticalSpaceInScreen = 0.7
  const heightToWidthRatio = 1.446

  const imageFullHeight = (window.innerHeight * verticalSpaceInScreen) / verticalSizeInImage / zoom
  const imageFullWidth = (imageFullHeight * heightToWidthRatio)
  const imageHeight = (imageFullHeight * verticalSizeInImage)
  const imageWidth = (imageFullWidth * horizontalSizeInImage)

  const marginTop = -imageFullHeight * topMargin
  const marginRight = Math.max(0, imageWidth * horizontalSizeInImage - window.innerWidth / 2) - imageFullWidth * rightMargin
  const marginBottom = -imageFullHeight * bottomMargin
  const marginLeft = -imageFullWidth * leftMargin
  calibreSpecStatsImage.style.marginTop = marginTop
  calibreSpecStatsImage.style.marginRight = marginRight
  calibreSpecStatsImage.style.marginBottom = marginBottom
  calibreSpecStatsImage.style.marginLeft = marginLeft
  calibreSpecStatsImage.style.height = imageFullHeight
  calibreSpecStatsImage.style.width = 'auto'
  document.querySelector('.calibre-spec-stats-image-container').style.width = (window.innerWidth / 2 / zoom) + 'px'
  document.querySelector('.calibre-spec-stats-image-container').style.height = imageHeight + 'px'
}

const specLinesFontLight = new FontFaceObserver('DINProCondensed', { weight: 100 })
const specLinesFontBold = new FontFaceObserver('DINProCondensed', { weight: 400 })
specLinesFontLight.load().then(_ => specLinesFontBold.load())
  .then(setUp).catch(setUp)
function setUp () {
  setUpSpecLines()
}

/* SECURITY MATRIX */
const securityMatrix = document.querySelector('.calibre-security-matrix p')
for (let i = 0; i < 5; ++i) {
  for (let j = 0; j <= 44; j++) {
    const digit = document.createElement('span')
    if ((i + j) % 2 === 0) {
      digit.innerHTML = ' '
    } else {
      digit.style.animationDuration = `${Math.round(100 * Math.random()) / 100 + 1}s`
      digit.style.animationDelay = `${Math.round(100 * Math.random() * 5) / 100}s`
      digit.innerHTML = Math.random() > 0.5 ? '1' : '0'
      // digit.addEventListener('animationstart', randomizeDigit)
      // digit.addEventListener('animationiteration', randomizeDigit)
    }
    securityMatrix.appendChild(digit)
  }
  securityMatrix.appendChild(document.createElement('br'))
}
/* EOF SECURITY MATRIX */

/* AVIONICS ELECTRIC BLUE TOGGLE */
let electricBlueEnabled = false
const ELECTRIC_BLUE = '#53DAF1'
function toggleElectricBlue () {
  if (electricBlueEnabled) {
    Array.from(document.querySelectorAll('.floating-specs-wrapper p, .avionics-ai-section h2, .avionics-ai-section svg g')).forEach(p => {
      p.style.color = ''
      p.style.fill = ''
      p.style.stroke = ''
    })
    document.querySelector('.avionics-ai-section').style.background = '#D6E0E1'
  } else {
    Array.from(document.querySelectorAll('.floating-specs-wrapper p, .avionics-ai-section h2, .avionics-ai-section svg g')).forEach(p => {
      p.style.color = ELECTRIC_BLUE
      p.style.fill = ELECTRIC_BLUE
      p.style.stroke = ELECTRIC_BLUE
    })
    document.querySelector('.avionics-ai-section').style.background = '#1B2526'
  }
  electricBlueEnabled = !electricBlueEnabled
}
toggleElectricBlue()

document.addEventListener('keydown', function (e) {
  if (e.key === 'b') toggleElectricBlue()
})
/* EOF AVIONICS ELECTRIC BLUE TOGGLE */

/* Calibre Card-Switching Alpha Video */
;(function () {
  const container = document.getElementById('calibre-card-switching-video-container')

  const video = container.querySelector('video')
  video.src = (video.canPlayType('video/webm; codecs="vp9"'))
    ? '/aerospace-application/witty-box-calibre/videos/calibre-card-switching.webm'
    : '/aerospace-application/witty-box-calibre/videos/calibre-card-switchingH264-small.mp4'

  let targetBreakpoint = 0
  const PHASE_TIME = 1

  //  3.14 phase
  //  0   : begin card 1
  //  1   : cenit card 1
  //  2   : end card 1 / begin card 2
  //  3   : cenit card 2
  //  4   : end card 2

  // -Infinity, 0, 1, Infinity
  let currentSection = -Infinity
  let targetTime = 0
  const SWITCHING_OUT = 0
  const SWITCHING_IN = 1
  const IDLE = 2
  let status = IDLE

  const sectionMarks = [
    [document.getElementById('calibre-card-switching-card0-mark'), 0, createFloatingDebuggingBlock()],
    [document.getElementById('calibre-card-switching-card1-mark'), 0, createFloatingDebuggingBlock()],
    [document.getElementById('calibre-card-switching-card2-mark'), 0, createFloatingDebuggingBlock()]
  ]

  function cacheSectionMarksY () {
    for (let i = 0; i < sectionMarks.length; ++i) {
      sectionMarks[i][1] = getPosition(sectionMarks[i][0]).y
      sectionMarks[i][2].style.top = sectionMarks[i][1] + 'px'
    }
  }
  window.cacheVideoSectionMarksY = cacheSectionMarksY
  cacheSectionMarksY()
  window.addEventListener('resize', cacheSectionMarksY)

  const floaty = createFloatingDebuggingBlock()
  floaty.style.background = 'blue'

  let videoIsReadyToPlay
  function setVideoIsReadyToPlay () {
    if (videoIsReadyToPlay) return
    videoIsReadyToPlay = true
    DEBUG && console.log('video can play!')

    // so that it shows the video's first frame instead
    video.poster = ''

    videoRenderLoop()

    video.oncanplaythrough = undefined
  }
  video.oncanplaythrough = setVideoIsReadyToPlay

  document.addEventListener('scroll', function () {
    let y = window.scrollY + (window.innerHeight / 2)
    y = y / zoom
    floaty.style.top = y + 'px'

    let i
    for (i = 0; i < sectionMarks.length; ++i) {
      if (y < sectionMarks[i][1]) break
    }
    const sectionToSwitchTo = (i - 1)

    if (sectionToSwitchTo >= 0 && sectionToSwitchTo <= 1 && currentSection !== sectionToSwitchTo) {
      if (!videoIsReadyToPlay) {
        // keep video in poster and suspend download
        // if we needed it to play and it couldn't
        video.src = ''
      }

      currentSection = sectionToSwitchTo

      if (video.paused) {
        video.play()
        DEBUG && console.log('told video to play')
      }

      targetTime = (PHASE_TIME + currentSection * PHASE_TIME * 2)
      const timeDistance = (targetTime - video.currentTime)
      if (timeDistance >= 0 && timeDistance <= PHASE_TIME) {
        // about to reach target, continue switching in
        status = SWITCHING_IN
        DEBUG && console.log('triggered switching in')
      } else {
        status = SWITCHING_OUT
        targetTime = (2 * PHASE_TIME - (video.currentTime % (2 * PHASE_TIME))) + video.currentTime
        DEBUG && console.log('triggered switching out')
      }
    }

    const isTextUncomfortable = (window.innerWidth <= 950)
    const shouldBlurVideo = (sectionToSwitchTo === 2 &&
                             isTextUncomfortable)
    video.classList.toggle('blur', shouldBlurVideo)
  })

  function videoRenderLoop () {
    requestAnimationFrame(videoRenderLoop)
    if (!video.paused) {
      const timeUntilTarget = (targetTime - video.currentTime)
      // if
      // - switching in or switching out, and
      // - target is in "the past"
      // - or target is more than twice ahead
      const targetWasReached = timeUntilTarget < 0
      const videoLoopedOver = timeUntilTarget >= 2 * PHASE_TIME
      if (targetWasReached || videoLoopedOver) {
        if (status === SWITCHING_IN) {
          DEBUG && console.log('switching in finished', video.currentTime)
          video.pause()
          status = IDLE
        } else if (status === SWITCHING_OUT) {
          DEBUG && console.log('switching out finished', video.currentTime)
          targetTime = Math.max(0, (PHASE_TIME + currentSection * PHASE_TIME * 2))
          status = SWITCHING_IN
          if (Math.abs(video.currentTime - (targetTime - PHASE_TIME)) > PHASE_TIME / 4) {
            // Needs a jump
            DEBUG && console.log('needs a jump', 'current', video.currentTime, 'target', targetTime)
            video.currentTime = targetTime - PHASE_TIME
            video.play()
          } else {
            DEBUG && console.log('no jump needed', video.currentTime)
          }
        }
      }
    }
  }
})()

/*
  MOBILE NAV BEHAVIOR
  hides when scrolling down
  shows when top is reached, or when scrolling up at some speed
*/
const mobileMenuToggle = document.querySelector('.mobile-menu-toggle')
const mobileMenu = document.querySelector('.mobile-menu')

// avoid initial transition of third hamburger line
Array.from(document.querySelectorAll('.mobile-menu-toggle div')).forEach(line => {
  line.style.transition = 'transform 0.5s'
})

let adjustMobileMenuVisibilityTimeout
function adjustMobileMenuVisibility () {
  clearTimeout(adjustMobileMenuVisibilityTimeout)
  if (document.body.classList.contains('mobile-menu-open')) {
    mobileMenu.style.visibility = 'visible'
  } else {
    mobileMenu.style.visibility = 'hidden'
  }
}

onTap(mobileMenuToggle, function () {
  clearTimeout(adjustMobileMenuVisibilityTimeout)
  document.body.classList.toggle('mobile-menu-open')

  // calls functions included in scroll-enabler.js
  if (document.body.classList.contains('mobile-menu-open')) {
    disableScroll()
    mobileMenu.style.visibility = 'visible'
  } else {
    enableScroll()
    adjustMobileMenuVisibilityTimeout = setTimeout(adjustMobileMenuVisibility, 1 * 1000)
  }
})

const mobileNav = document.querySelector('.mobile-nav')
let prevScrollTop = window.scrollY
let yOffsetMobileNav = 0
const minYoffsetMobileNav = -100
const maxYoffsetMobileNav = 0
let speedBreak = false

function adjustMobileNavPosition (scrollTop) {
  const delta = scrollTop - prevScrollTop
  prevScrollTop = scrollTop
  if (mobileNavIgnoreNextScroll) {
    // resize could have been caused by mobile browser bar minizing
    // which can happen while scrolling down
    mobileNavIgnoreNextScroll = false
    return
  }

  if (delta < 0 || scrollTop <= 0) {
    // going up
    speedBreak |= (delta < -20)
    if (speedBreak || yOffsetMobileNav > minYoffsetMobileNav || scrollTop <= 0) {
      mobileNav.style.transition = 'transform 0.5s'
      yOffsetMobileNav = 0
    }
  } else {
    // going down
    speedBreak = false
    mobileNav.style.transition = 'transform 16ms'
    yOffsetMobileNav -= delta
  }

  yOffsetMobileNav = Math.min(yOffsetMobileNav, maxYoffsetMobileNav)
  yOffsetMobileNav = Math.max(yOffsetMobileNav, minYoffsetMobileNav)

  mobileNav.style.transform = `translateY(${yOffsetMobileNav - 1}px)`
}

/* RESIZE HANDLER */
let mobileNavIgnoreNextScroll = false
let initialInnerHeight = null
let nextInitialInnerHeight = null
let updateLastInnerHeightTimeout = null
let previousInnerWidth = 0
function updateInitialInnerHeight () {
  initialInnerHeight = nextInitialInnerHeight
}

let textWasMobile = false
const storageGpgpuTextSection = document.querySelector('.storage-and-gpgpu-section .text-section-js')
const bestInClassInterfacesLastSpacer = document.querySelector('.class-interfaces-section .spacer2')
const xrayMachines = Array.from(document.querySelectorAll('.xray-machine img, .machine-wrapper'))
function onWindowResize () {
  const isMobile = (window.innerWidth <= MOBILE_BREAKPOINT)
  const textShouldBeMobile = (window.innerWidth <= 849)
  if (textWasMobile !== textShouldBeMobile) {
    textWasMobile = textShouldBeMobile
    if (textShouldBeMobile) {
      document.querySelector('.storage-and-gpgpu-section .mobile-text-section-destination-js').appendChild(storageGpgpuTextSection)
    } else {
      document.querySelector('.storage-and-gpgpu-section .desktop-text-section-destination-js').appendChild(storageGpgpuTextSection)
    }
  }

  mobileNavIgnoreNextScroll = true

  // we don't immediately update `initialInnerHeight. We wait until the
  // series of resize events (part of the same resize intent) stop.
  // If we immediately updated `initialInnerHeight`, some of the next
  // resize events in the series would be ignored, and the last
  // non-ignored resize event in the series (the final one) would likely
  // be ignored as well.
  nextInitialInnerHeight = window.innerHeight
  clearTimeout(updateLastInnerHeightTimeout)
  updateLastInnerHeightTimeout = setTimeout(updateInitialInnerHeight, 300)

  // if difference is not significant, ignore resize.
  // useful for mobile, because scrolling can hide search bars,
  // minimize bottom action bar, and this would cause rezing the device
  // which is undesirable in that case.

  // If they ARE the same height, allow the recalculation.
  // Consider it a forced one.
  const dontResizeElements = (initialInnerHeight != null &&
      Math.abs(initialInnerHeight - window.innerHeight) < 100 && initialInnerHeight !== window.innerHeight)
  const shouldResizeElements = !dontResizeElements || (previousInnerWidth !== window.innerWidth)
  previousInnerWidth = window.innerWidth
  DEBUG && console.log('shouldResizeElements', shouldResizeElements)

  // in firefox, there's no zoom support.
  // 4.13% firefox desktop usage
  // 0.23% firefox mobile usage
  if (shouldResizeElements && !isFirefox) {
    zoom = 1
    if (window.innerWidth > 1280) {
      zoom = window.innerWidth / 1280
    } else if (window.innerWidth < MOBILE_BREAKPOINT) {
      zoom = window.innerWidth / 375
    }
    document.body.style.zoom = zoom
  }

  if (shouldResizeElements) {
    adjustSlidesHeight()

    /* adjust the position at which the xray machine gets stuck when
      scrolling, which is affected by viewport height */
    // we need to divide by zoom, otherwise we get:
    // `viewportHeight * (manual) zoom`
    const viewportHeight = window.innerHeight / zoom
    const imageYCenterOfGravity = (430 / 800)
    if (isMobile) {
      /* TODO: xray machine should get bigger if the space is enough...
        and the bigger size will affect this */
      const textHeight = 270
      const machineHeight = 405
      const top = textHeight +
                  (viewportHeight - textHeight) / 2 -
                  imageYCenterOfGravity * machineHeight
      machine.style.top = `${top}px`
      machineOffsetTop = top
    } else {
      const textHeight = 180 // 130
      let machineHeight = 800
      const machineHeightWithEnoughMargin = 764 // (800 * 0.955)
      const machineImageMarginTop = 0.17
      const machineImageContentHeight = 0.8
      let top = textHeight +
                  (viewportHeight - textHeight) / 2 -
                  imageYCenterOfGravity * machineHeight
      if (top + machineHeightWithEnoughMargin > viewportHeight) {
        top = viewportHeight - machineHeightWithEnoughMargin
        const space = viewportHeight - textHeight
        machineHeight = space / machineImageContentHeight
        // set image height to machine height
        const widthToHeightRatio = 700 / 800
        xrayMachines.forEach(machine => {
          machine.style.height = machineHeight + 'px'
          machine.style.width = machineHeight * widthToHeightRatio + 'px'
        })
        top = textHeight - machineHeight * machineImageMarginTop
      }
      machine.style.top = `${top}px`
      machineOffsetTop = top
    }

    /* adjust best-in-class-interfaces last spacer height in firefox,
       since on a taller design, the specs drift away more due to parallax */
    if (isFirefox) {
      bestInClassInterfacesLastSpacer.style.paddingBottom = window.innerHeight * 0.1 + 'px'
    }
  }

  /* update the y position for the different marks */
  xrayY = getPosition(xrayLine).y
  techStatsY = getPosition(techStats).y
  xrayMachineStartPinY = getPosition(document.querySelector('.js-xray-machine-topY')).y - machineOffsetTop
  xrayMachineEndPinY = getPosition(document.querySelector('.js-xray-machine-bottomY')).y - machineOffsetTop - machineHeight
  trueMultiCoreCueY = getPosition(document.querySelector('.js-true-multi-core-cue')).y
  const avionicsHeart = document.querySelector('.avionics-heart')
  avionicsHeartY = getPosition(avionicsHeart).y

  if (shouldResizeElements) {
    adjustBlackSpecStatsSection()
  }
  adjustParallaxItemsData()

  onScroll()
}
onWindowResize()
window.addEventListener('resize', onWindowResize)

// to avoid misadjustments because of images loading later
// "just in case" catch all
setInterval(function () {
  window.cacheVideoSectionMarksY()
  adjustParallaxItemsData()
  adjustParallaxItems()
}, 1000)
